import { FC } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import AdminPlaylistsList from './AdminPlaylistsList';
import AdminPlaylistPage from './AdminPlaylistPage';
import { AdminPlaylistLandingPage } from './AdminPlaylistLandingPage/AdminPlaylistLandingPage';

const useStyles = makeStyles()(() => ({
  container: {
    height: '100%',
  },
}));

export const AdminPlaylistsPage: FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Routes>
        <Route index element={<AdminPlaylistsList />} />
        <Route path="create" element={<AdminPlaylistPage />} />
        <Route path=":playlistId/edit" element={<AdminPlaylistPage />} />
        <Route path=":playlistId/*" element={<AdminPlaylistLandingPage />} />
      </Routes>
    </Box>
  );
};

export default AdminPlaylistsPage;
